// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Result_wrapper__1H-WZ","text":"Result_text__Kiv4u","section":"Result_section__1XTsV","title":"Result_title__2_UH9","chartContainer":"Result_chartContainer__2JWml"};